import { Component, OnInit, NgZone, ApplicationRef } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'src/app/classes/globals.class';

declare let App: any;
declare let $: any;
declare let swal: any;
declare let moment: any;
declare let tinymce: any;
declare let toastr: any;
declare let ICAL: any;

@Component({
  selector: 'app-edit-alojamiento',
  templateUrl: './edit-alojamiento.component.html'
})
export class EditAlojamientoComponent implements OnInit {
  public title:string = 'Nuevo alojamiento';
  public data:any = {
    id: '',
    adultos: 2,
    ninos: 0,
    num_minimo_noches: 2
  };
  public imgsubir:string = '';
  public dataitem:any = {};
  public temporadas = [];
  public fechas_bloqueadas = [];
  public fechas_reservadas = [];
  public fechas_bloqueadas_booking = [];
  public fechas_bloqueadas_airbnb= [];
  public alojamientos = [];
  public fechas_bloqueadas_rango = [];
  public num_minimo_noches:number = 1;

  constructor(
    public ngZone: NgZone,
    public router: Router,
    public appref: ApplicationRef,
    public globals: Globals
  ) { }

  ngOnInit(): void {
    App.init();
    $.disableinputnumberwheel();
    $.checkrolredirect(3); //No clientes
    if (window.location.pathname.indexOf('add') != -1) this.globals.passData = null;
    if (window.location.pathname.indexOf('edit') != -1 && !Object.keys(this.globals.passData).length) window.location.href = window.location.href.replace('edit', 'add');
    if (this.globals.passData && this.globals.passData != '' && Object.keys(this.globals.passData).length > 0) this.data = this.globals.passData;
    if (!this.data.id || this.data.id == '') {
      this.title = 'Nuevo alojamiento';
    } else {
      this.title = this.data.nombre;
    }
    if (this.globals.GetData('temporadas')) this.temporadas = this.globals.GetData('temporadas');
    this.globals.Api('/alo-temporadas').subscribe(data => {
      if (!data || !data.length) {
        this.temporadas = [];
        this.globals.SaveData([], 'temporadas');
        return;
      }
      this.globals.SaveData(data, 'temporadas');
      this.temporadas = data;
    });
    tinymce.remove();
    setTimeout(() => {
      let move = function (arr, from, to) {
        arr.splice(to, 0, arr.splice(from, 1)[0]);
      };
      let that = this;
      tinymce.init({
        selector:'.text-editor',
        height: 300,
        plugins: 'print preview powerpaste casechange importcss tinydrive searchreplace autolink autosave save directionality advcode visualblocks visualchars fullscreen image link media mediaembed template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists checklist wordcount tinymcespellchecker a11ychecker imagetools textpattern noneditable help formatpainter permanentpen pageembed charmap tinycomments mentions quickbars linkchecker emoticons advtable',
        toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media pageembed template link anchor codesample | a11ycheck ltr rtl | showcomments addcomment',
        language: 'es'
      });
      // $('#tab-imagenes .gallery').sortable({
      $('#tab-general .gallery').sortable({
        stop: (event, ui) => {
          let arr = [];
          $('#tab-general .gallery .ui-sortable-handle').each(function() {
            let id = $(this).attr('itemid');
            if (!id || id == '') return;
            arr.push(id);
          });
          if (!that.data.id || that.data.id == '') return;
          that.globals.Api('/alo-alojamientos-imagenes-order', {id_alojamiento: that.data.id, ordenid: arr}).subscribe(data => {
            toastr.success(`Orden cambiado correctamente`, 'Orden cambiado');
          });
        }
      });
      // $('#tab-caracteristicas table tbody').sortable({
      $('#tab-general .table-caracteristicas tbody').sortable({
        stop: (event, ui) => {
          let arr = [];
          $('#tab-general .table-caracteristicas tbody tr').each(function() {
            let id = $(this).attr('itemid');
            if (!id || id == '') return;
            arr.push(id);
          });
          if (!that.data.id || that.data.id == '') return;
          that.globals.Api('/alo-alojamientos-caracteristicas-order', {id_alojamiento: that.data.id, ordenid: arr}).subscribe(data => {
            toastr.success(`Orden cambiado correctamente`, 'Orden cambiado');
          });
        }
      });
      $('#tab-servicios table tbody').sortable({
        stop: (event, ui) => {
          let arr = [];
          $('#tab-servicios table tbody tr').each(function() {
            let id = $(this).attr('itemid');
            if (!id || id == '') return;
            arr.push(id);
          });
          if (!that.data.id || that.data.id == '') return;
          that.globals.Api('/alo-alojamientos-servicios-order', {id_alojamiento: that.data.id, ordenid: arr}).subscribe(data => {
            toastr.success(`Orden cambiado correctamente`, 'Orden cambiado');
          });
        }
      });
      $('#tab-tarifas table tbody').sortable({
        stop: (event, ui) => {
          let arr = [];
          $('#tab-tarifas table tbody tr').each(function() {
            let id = $(this).attr('itemid');
            if (!id || id == '') return;
            arr.push(id);
          });
          if (!that.data.id || that.data.id == '') return;
          that.globals.Api('/alo-alojamientos-tarifas-order', {id_alojamiento: that.data.id, ordenid: arr}).subscribe(data => {
            this.globals.Api('/alo-alojamientos', {id: this.data.id}).subscribe(data => {
              if (data && data.length) this.data.tarifas = data[0].tarifas;
            });
          });
        }
      });
      let html = '';
      this.iconos.forEach(icon => {
        html += `<option value="icofont-${icon}">${icon}</option>`;
      });
      $('.chosen-iconos select').html(html);
      $('.chosen-iconos option').each(function() {
        $(this).html('<i class="icofont-'+$(this).html()+'"></i> '+$(this).html());
      })
      $('.chosen-select').chosen({width: "100%"});
      this.LoadFechasBloqueadas();
    }, 100);
    this.LoadFechasBloqueadasRango();
    $('#date-rangue-block-start').change(function(){
      $('#date-rangue-block-end').attr('min',$('#date-rangue-block-start').val());
    });
  }
  LoadFechasBloqueadas() {
    function getDates(startDate, stopDate) {
      let dateArray = [];
      let currentDate = new Date(startDate);
      stopDate = new Date(stopDate);
      while (currentDate <= stopDate) {
        dateArray.push(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
      }
      return dateArray;
    }

    this.fechas_bloqueadas = [];
    if (this.data.fechas_bloqueadas) {
      for (let item of this.data.fechas_bloqueadas) {
        if (!item || !item.fecha_format2) continue;
        this.fechas_bloqueadas.push(item.fecha_format2);
      }
    }
    if (this.data.fechas_reservadas) {
      for (let item of this.data.fechas_reservadas) {
        if (!item || !item.fecha_llegada_format2) continue;
        let dates = getDates(item.fecha_llegada_format2, item.fecha_salida_format2);
        for (let fecha of dates) {
          fecha = moment(fecha).format('YYYY-MM-DD');
          this.fechas_reservadas.push(fecha);
        }
      }
    }

    if (this.data.id && this.data.id != '') {
      this.globals.Api('/get-ics/'+this.data.id).subscribe(data => {
        if (!data) return;
        this.fechas_bloqueadas_booking = [];
        if (data.ics_booking && data.ics_booking != '') {
          let jcalData = ICAL.parse(data.ics_booking);
          let vcalendar = new ICAL.Component(jcalData);
          let vevents = vcalendar.getAllSubcomponents("vevent");
          for (let event of vevents) {
            let uid = event.getFirstPropertyValue('uid');
            let start = event.getFirstPropertyValue('dtstart');
            let end = event.getFirstPropertyValue('dtend');
            start = moment(new Date(start.year, start.month-1, start.day)).format('YYYY-MM-DD');
            end = moment(new Date(end.year, end.month-1, end.day)).format('YYYY-MM-DD');
            let dates = getDates(start, end);
            // console.log(uid);
            for (let fecha of dates) {
              fecha = moment(fecha).format('YYYY-MM-DD');
              this.fechas_bloqueadas_booking.push(fecha);
            }
          }
        }
        this.fechas_bloqueadas_airbnb = [];
        if (data.ics_airbnb && data.ics_airbnb != '') {
          let jcalData = ICAL.parse(data.ics_airbnb);
          let vcalendar = new ICAL.Component(jcalData);
          let vevents = vcalendar.getAllSubcomponents("vevent");
          for (let event of vevents) {
            let uid = event.getFirstPropertyValue('uid');
            let start = event.getFirstPropertyValue('dtstart');
            let end = event.getFirstPropertyValue('dtend');
            start = moment(new Date(start.year, start.month-1, start.day)).format('YYYY-MM-DD');
            end = moment(new Date(end.year, end.month-1, end.day)).format('YYYY-MM-DD');
            let dates = getDates(start, end);
            // console.log(uid);
            for (let fecha of dates) {
              fecha = moment(fecha).format('YYYY-MM-DD');
              this.fechas_bloqueadas_airbnb.push(fecha);
            }
          }
        }
        this.appref.tick();
        $('#calendario-cierres').datepicker('update');
      });
    }

    /*Bloqueos*/
    $('#calendario-cierres').datepicker({
      todayBtn: "linked",
      keyboardNavigation: false,
      changeMonth: true,
      changeYear: true,
      showButtonPanel: true,
      weekStart: 1,
      language: 'es',
      format: "dd/mm/yyyy",
      beforeShowDay: date => {
        let fecha = moment(date).format('YYYY-MM-DD');
        if (this.fechas_bloqueadas.indexOf(fecha) != -1) {
          // return false;
          return {classes: 'bloqueada'};
        }
        if (this.fechas_reservadas.indexOf(fecha) != -1) {
          // return false;
          return {classes: 'bloqueada reservada'};
        }
        if (this.fechas_bloqueadas_booking.indexOf(fecha) != -1
          && this.fechas_bloqueadas_airbnb.indexOf(fecha) != -1) {
          return {classes: 'bloqueada booking-airbnb'};
        }
        if (this.fechas_bloqueadas_booking.indexOf(fecha) != -1) {
          return {classes: 'bloqueada booking'};
        }
        if (this.fechas_bloqueadas_airbnb.indexOf(fecha) != -1) {
          return {classes: 'bloqueada airbnb'};
        }
      }
    });
    $('#calendario-cierres').datepicker().on('changeDate', ev => {
      let fecha = moment($('#calendario-cierres').datepicker('getDate')).format('YYYY-MM-DD');
      let that = this;
      if (this.fechas_bloqueadas.indexOf(fecha) != -1) {
        swal({
          title: "¿Desbloquear fecha?",
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn-primary",
          confirmButtonText: "Sí",
          cancelButtonText: "No",
          closeOnConfirm: true
        }, function(isConfirmed) {
          if (!isConfirmed) {
            $('#calendario-cierres').datepicker('update', moment(fecha).format('DD-MM-YYYY'));
            return true;
          }
          if (!that.data.id || that.data.id == '') {
            if (that.data.fechas_bloquedas) that.data.fechas_bloquedas.splice(that.data.fechas_bloquedas.findIndex(el => el.fecha == fecha), 1);
            if (that.fechas_bloqueadas) that.fechas_bloqueadas.splice(that.fechas_bloqueadas.findIndex(el => el == fecha), 1);
            $('#calendario-cierres').datepicker('update', moment(fecha).format('DD-MM-YYYY'));
            return;
          }
          that.globals.Api('/alo-alojamientos-fechas-bloqueadas-del', {id_alojamiento: that.data.id, fecha: fecha}).subscribe(data => {
            if (!data || data.error) {
              swal('Error', 'Se ha producido un error', 'error');return;
            }
            if (that.data.fechas_bloquedas) that.data.fechas_bloquedas.splice(that.data.fechas_bloquedas.findIndex(el => el.fecha == fecha), 1);
            if (that.fechas_bloqueadas) that.fechas_bloqueadas.splice(that.fechas_bloqueadas.findIndex(el => el == fecha), 1);
            $('#calendario-cierres').datepicker('update', moment(fecha).format('DD-MM-YYYY'));
          });
        });
        return;
      };
      swal({
        title: "¿Bloquear fecha?",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn-primary",
        confirmButtonText: "Sí",
        cancelButtonText: "No",
        closeOnConfirm: true
      }, function(isConfirmed) {
        if (!isConfirmed) {
          $('#calendario-cierres').datepicker('update', moment(fecha).format('DD-MM-YYYY'));
          return true;
        }
        if (!that.data.id || that.data.id == '') {
          if (!that.data.fechas_bloquedas) that.data.fechas_bloquedas = [];
          that.data.fechas_bloquedas.push({id_alojamiento: that.data.id, fecha: fecha});
          that.fechas_bloqueadas.push(fecha);
          return;
        }
        that.globals.Api('/alo-alojamientos-fechas-bloqueadas-add', {id_alojamiento: that.data.id, fecha: fecha}).subscribe(data => {
          if (!data || data.error) {
            swal('Error', 'Se ha producido un error', 'error');return;
          }
          if (!that.data.fechas_bloquedas) that.data.fechas_bloquedas = [];
          if (!that.fechas_bloqueadas) that.fechas_bloqueadas = [];
          that.data.fechas_bloquedas.push({id_alojamiento: that.data.id, fecha: fecha});
          that.fechas_bloqueadas.push(fecha);
          $('#calendario-cierres').datepicker('update', moment(fecha).format('DD-MM-YYYY'));
        });
      });
    });
  }
  LoadFechasBloqueadasRango(){
    console.log('Id alojamiento: ' + this.data.id);
    this.globals.Api('/alo-alojamientos-fechas-bloqueadas-rango', this.data).subscribe(data => {
      if (!data || !data.length) {
        this.fechas_bloqueadas_rango = [];
        this.globals.SaveData([], 'fechas-bloqueadas-rango');
        return;
      }
      this.globals.SaveData(data, 'fechas-bloqueadas-rango');
      this.fechas_bloqueadas_rango = data;
    });
  }
  LoadFechasMinimoNoches() {
    if (!this.data.id || this.data.id == '') return;
    let that = this;
    $('#calendario-noches').daterangepicker({
      alwaysShowCalendars: true,
      opens: 'right',
      autoUpdateInput: false,
      locale: {
        "format": "DD/MM/YYYY",
        "separator": " - ",
        "applyLabel": "Aplicar",
        "cancelLabel": "Cancel",
        "fromLabel": "Desde",
        "toLabel": "Hasta",
        "customRangeLabel": "Personalizado",
        "weekLabel": "S",
        "daysOfWeek": [
            "Do",
            "Lu",
            "Ma",
            "Mi",
            "Ju",
            "Vi",
            "Sa"
        ],
        "monthNames": [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Diciembre"
        ],
        "firstDay": 1
      },
      isCustomDate: function(date) {
        if (!that.data || !that.data.minimo_noches || !that.data.minimo_noches.length) return;
        if (!that.data.hclassnum) that.data.hclassnum = 1;
        for (let item of that.data.minimo_noches) {
          if (!item.hclass) {
            item.hclass = 'highlight-' + that.data.hclassnum;
            that.data.hclassnum++;
            if (that.data.hclassnum>5) that.data.hclassnum = 1;
          }
          let startDate   = moment(item.fecha_inicio).add(-1, 'days');
          let endDate     = moment(item.fecha_fin).add(1, 'days');
          if (date.isBetween(startDate, endDate)) {
            return [item.hclass];
          }
        }
        $.ResetColores = () => {
          for (let item of that.data.minimo_noches) item.hclass = null;
        };
      }
    });
    $('#calendario-noches-container').append($('.daterangepicker'));
    setTimeout(() => {
      $('#calendario-noches').trigger('click');
    }, 20);
  }
  SelecImagen() {
    let input = this.globals.FileInput('image/*', event => {
      this.globals.Base64Image(input, base64 => {
        this.data.imagen = base64;
        this.imgsubir = base64;
        this.appref.tick();
      });
    });
    input.click();
  }
  BorrarImagen(event:any) {
    event.stopPropagation();
    swal({
      title: "¿Borrar imagen principal del alojamiento?",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn-primary",
      confirmButtonText: "Sí",
      cancelButtonText: "No",
      closeOnConfirm: true
    },() => {
      if (!this.data.id || this.data.id == '') {
        this.imgsubir = '';
        this.data.imagen = '';
        return;
      }
      this.globals.Api('/borrar-imagen-alojamiento', {id: this.data.id}).subscribe(data => {
        if (!data || data.error) {
          swal('Error', 'Se ha producido un error', 'error');return;
        }
        this.imgsubir = '';
        this.data.imagen = '';
        this.appref.tick();
      });
    });
  }

  Cancelar() {
    this.ngZone.run(() => this.router.navigateByUrl('/alojamientos')).then();
  }
  Guardar() {
    this.data.descripcion = tinymce.EditorManager.get('txtdescripcion').getContent();
    if (
      !this.data.nombre
      || !this.data.descripcion
      || !this.data.adultos
      || this.data.nombre == ''
      || this.data.descripcion == ''
      || this.data.adultos == ''
      ) {
      swal('Complete campos', 'Por favor, rellene todos los campos obligatorios para continuar', 'error');return;
    }
    if (!this.data.num_minimo_noches 
      || isNaN(this.data.num_minimo_noches) 
      || this.data.num_minimo_noches == '' 
      || parseInt(this.data.num_minimo_noches) < 1) {
      swal('Número mínimo no válido', 'El número de noches mínimas para reservar no es válido', 'error');return;
    }
    this.data.tipo = 'casa-rural';

    this.data.img = null;
    if (this.imgsubir != '') this.data.img = this.imgsubir;
    this.title = this.data.nombre;

    if (!this.data.id || this.data.id == '') {
      $.buttonloading('.btn-guardar', 'Enviando');
      this.globals.Api('/alo-alojamientos-add', this.data).subscribe(data => {
        $.buttoncancelloading('.btn-guardar');
        if (!data || data.error) {
          swal('Error', 'Se ha producido un error', 'error');return;
        }
        this.Cancelar();
      }, error => {
        $.buttoncancelloading('.btn-guardar');
      });
    } else {
      $.buttonloading('.btn-guardar', 'Enviando');
      this.globals.Api('/alo-alojamientos-edit', this.data).subscribe(data => {
        $.buttoncancelloading('.btn-guardar');
        if (!data || data.error) {
          swal('Error', 'Se ha producido un error', 'error');return;
        }
        // swal('Guardado', 'Datos guardados correctamente', 'success');
        toastr.success(`Datos guardados correctamente`, 'Guardado');
        this.LoadFechasBloqueadas();
      }, error => {
        $.buttoncancelloading('.btn-guardar');
      });
    }
  }

  //Galeria de imagenes
  AddImagen() {
    let input = this.globals.FileInput('image/*', event => {
      this.globals.Base64Image(input, base64 => {
        // this.data.imagen = base64;
        // this.imgsubir = base64;
        this.appref.tick();
        if (!this.data.id || this.data.id == '') {
          if (!this.data.imagenes) this.data.imagenes = [];
          this.data.imagenes.push({imagen: base64});
          return;
        }
        $.buttonloading('btn-add-imagen', 'Enviando');
        this.globals.Api('/alo-alojamientos-imagenes-add', {id_alojamiento: this.data.id, imagen: base64}).subscribe(data => {
          $.buttoncancelloading('btn-add-imagen');
          if (!data || data.error) {
            swal('Error', 'Se ha producido un error', 'error');return;
          }
          if (!this.data.imagenes) this.data.imagenes = [];
          this.data.imagenes.push({id: data.value, imagen: base64});
        }, error => {
          $.buttoncancelloading('btn-add-imagen');
        });

      });
    });
    input.click();
  }
  DelImagen(event:any, item:any) {
    event.stopPropagation();
    if (!item || !item.id) {
      this.data.imagenes.splice(this.data.imagenes.findIndex(el => el.imagen == item.imagen), 1);
      return;
    }
    if (!this.data.id || this.data.id == '') return;
    swal({
      title: "¿Borrar imagen?",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn-primary",
      confirmButtonText: "Sí",
      cancelButtonText: "No",
      closeOnConfirm: true
    },() => {
      this.globals.Api('/alo-alojamientos-imagenes-del', {id_alojamiento: this.data.id, id: item.id}).subscribe(data => {
        if (!data || data.error) {
          swal('Error', 'Se ha producido un error', 'error');return;
        }
        this.data.imagenes.splice(this.data.imagenes.findIndex(el => el.id == item.id), 1);
        this.appref.tick();
      });
    });
  }

  //Caracteristicas
  CaracteristicaDefecto(icon, label) {
    this.dataitem.caracteristica = label;
    this.dataitem.icono = icon;
    $('.cmb-icono-caracteristica .chosen-single span').html(`<i class="${icon}"></i> ${icon}`);
  }
  AddCaracteristica() {
    $('#modal-crear-caracteristica').modal('show');
    $('#modal-crear-caracteristica .modal-title').html('Nueva característica');
    Object.keys(this.dataitem).forEach(item => {this.dataitem[item] = ''});
    setTimeout(() => {
      $('#modal-crear-caracteristica input[type="text"]')[0].focus();
    }, 500);
  }
  DelCaracteristica(item:any) {
    if (!item || !item.id) {
      this.data.caracteristicas.splice(this.data.caracteristicas.findIndex(el => el.caracteristica == item.caracteristica), 1);
      return;
    }
    if (!this.data.id || this.data.id == '') return;
    swal({
      title: "¿Borrar característica?",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn-primary",
      confirmButtonText: "Sí",
      cancelButtonText: "No",
      closeOnConfirm: true
    },() => {
      this.globals.Api('/alo-alojamientos-caracteristicas-del', {id_alojamiento: this.data.id, id: item.id}).subscribe(data => {
        if (!data || data.error) {
          swal('Error', 'Se ha producido un error', 'error');return;
        }
        this.data.caracteristicas.splice(this.data.caracteristicas.findIndex(el => el.id == item.id), 1);
        this.appref.tick();
      });
    });
  }
  GuardarCaracteristica() {
    this.dataitem.icono = $('.cmb-icono-caracteristica .chosen-single i').attr('class');
    if (
      this.dataitem.caracteristica == ''
      || !this.dataitem.caracteristica
      || this.dataitem.icono == ''
      || !this.dataitem.icono
      ) {
      swal('Complete campos', 'Por favor, rellene todos los campos obligatorios para continuar', 'error');return;
    }

    if (!this.data.id || this.data.id == '') {
      if (!this.data.caracteristicas) this.data.caracteristicas = [];
      this.data.caracteristicas.push({caracteristica: this.dataitem.caracteristica, icono: this.dataitem.icono});
      $('#modal-crear-caracteristica').modal('hide');
      return;
    }
    
    $.buttonloading('btn-guardar-caracteristica', 'Enviando');
    this.dataitem.id_alojamiento = this.data.id;
    this.globals.Api('/alo-alojamientos-caracteristicas-add', this.dataitem).subscribe(data => {
      $.buttoncancelloading('btn-guardar-caracteristica');
      if (!data || data.error) {
        swal('Error', 'Se ha producido un error', 'error');return;
      }
      if (!this.data.caracteristicas) this.data.caracteristicas = [];
      this.data.caracteristicas.push({id: data.value, caracteristica: this.dataitem.caracteristica, icono: this.dataitem.icono});
      $('#modal-crear-caracteristica').modal('hide');
    }, error => {
      $.buttoncancelloading('btn-guardar-caracteristica');
    });
  }

  //Servicios
  AddServicio() {
    $('#modal-crear-servicio').modal('show');
    $('#modal-crear-servicio .modal-title').html('Nuevo servicio');
    Object.keys(this.dataitem).forEach(item => {this.dataitem[item] = ''});
    setTimeout(() => {
      $('#modal-crear-servicio input[type="text"]')[0].focus();
    }, 500);
  }
  DelServicio(item:any) {
    if (!item || !item.id) {
      this.data.servicios.splice(this.data.servicios.findIndex(el => el.servicio == item.servicio), 1);
      return;
    }
    if (!this.data.id || this.data.id == '') return;
    swal({
      title: "¿Borrar servicio?",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn-primary",
      confirmButtonText: "Sí",
      cancelButtonText: "No",
      closeOnConfirm: true
    },() => {
      this.globals.Api('/alo-alojamientos-servicios-del', {id_alojamiento: this.data.id, id: item.id}).subscribe(data => {
        if (!data || data.error) {
          swal('Error', 'Se ha producido un error', 'error');return;
        }
        this.data.servicios.splice(this.data.servicios.findIndex(el => el.id == item.id), 1);
        this.appref.tick();
      });
    });
  }
  GuardarServicio() {
    this.dataitem.icono = $('.cmb-icono-servicio .chosen-single i').attr('class');
    if (
      this.dataitem.servicio == ''
      || !this.dataitem.servicio
      || this.dataitem.icono == ''
      || !this.dataitem.icono
      ) {
      swal('Complete campos', 'Por favor, rellene todos los campos obligatorios para continuar', 'error');return;
    }

    if (!this.data.id || this.data.id == '') {
      if (!this.data.servicios) this.data.servicios = [];
      this.data.servicios.push({servicio: this.dataitem.servicio, icono: this.dataitem.icono});
      $('#modal-crear-servicio').modal('hide');
      return;
    }
    
    $.buttonloading('btn-guardar-servicio', 'Enviando');
    this.dataitem.id_alojamiento = this.data.id;
    this.globals.Api('/alo-alojamientos-servicios-add', this.dataitem).subscribe(data => {
      $.buttoncancelloading('btn-guardar-servicio');
      if (!data || data.error) {
        swal('Error', 'Se ha producido un error', 'error');return;
      }
      if (!this.data.servicios) this.data.servicios = [];
      this.data.servicios.push({id: data.value, servicio: this.dataitem.servicio, icono: this.dataitem.icono});
      $('#modal-crear-servicio').modal('hide');
    }, error => {
      $.buttoncancelloading('btn-guardar-servicio');
    });
  }

  //Tarifas
  OrdenarTarifas() {
    if (!this.data.id || this.data.id == '') return;
    swal({
      title: "¿Ordenar tarifas?",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn-primary",
      confirmButtonText: "Sí",
      cancelButtonText: "No",
      closeOnConfirm: true
    },() => {
      this.globals.Api('/alo-alojamientos-tarifas-reorder', {id: this.data.id}).subscribe(data => {
        if (!data || !data.length) return;
        this.data.tarifas = data;
        this.appref.tick();
      });
    });
  }
  DelAllTarifas() {
    swal({
      title: "¿Borrar todas las tarifas?",
      text: 'Se borrarán las tarifas actuales',
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn-primary",
      confirmButtonText: "Sí",
      cancelButtonText: "No",
      closeOnConfirm: true
    },() => {
      this.data.tarifas = [];
    });
  }
  ImportarTarifas() {
    $('#modal-importar-tarifas').modal('show');
    $('#modal-importar-tarifas .modal-title').html('Importar tarifas');
    this.globals.Api('/alo-alojamientos', {excludeid: this.data.id}).subscribe(data => {
      if (!data || !data.length) {
        this.alojamientos = [];
        return;
      }
      this.alojamientos = data;
      if (this.alojamientos.length) this.dataitem.id = this.alojamientos[0].id;
      this.appref.tick();
    });
  }
  ImportTarifas() {
    swal({
      title: "¿Importar tarifas?",
      text: 'Se borrarán las tarifas actuales',
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn-primary",
      confirmButtonText: "Sí",
      cancelButtonText: "No",
      closeOnConfirm: true
    },() => {
      this.data.tarifas = [];
      this.globals.Api('/alo-alojamientos', {id: this.dataitem.id}).subscribe(data => {
        if (!data || !data.length) {
          swal('Error', 'Se ha producido un error', 'error');return;
        }
        data = data[0];
        this.data.tarifas = data.tarifas;
        $('#modal-importar-tarifas').modal('hide');
      });
    });
  }
  GenerarTarifas() {
    if (!this.data.adultos || this.data.adultos == '') {
      swal('Complete campos', 'Por favor, introduce el número de adultos para continuar', 'error');return;
    }
    swal({
      title: "Generar tarifas por defecto?",
      text: 'Se borrarán las tarifas actuales',
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn-primary",
      confirmButtonText: "Sí",
      cancelButtonText: "No",
      closeOnConfirm: true
    },() => {
      let maxninos = (this.data.ninos ? this.data.ninos : 0);
      this.data.tarifas = [];
      this.globals.Api('/alo-temporadas').subscribe(data => {
        if (!data || !data.length) {
          swal('Error', 'Se ha producido un error', 'error');return;
        }
        this.data.tarifas = [];
        for (let item of data) {
          for (let adultos = this.data.adultos; adultos >= 1;adultos--) {
            for (let ninos = maxninos; ninos >= 0;ninos--) {
              let max = 0;
              this.data.tarifas.forEach(item => {if (parseInt(item.id) > max) max = item.id;});
              max = max+1;
              this.data.tarifas.push({
                id_temporada: item.id,
                id: max,
                temporada: item.temporada, 
                adultos: adultos,
                ninos: ninos,
                precio: '10',
                pordefecto: 0
              });
            }
          }
        }
        for (let adultos = this.data.adultos; adultos >= 1;adultos--) {
          for (let ninos = maxninos; ninos >= 0;ninos--) {
            let max = 0;
            this.data.tarifas.forEach(item => {if (parseInt(item.id) > max) max = item.id;});
            max = max+1;
            this.data.tarifas.push({
              id_temporada: null,
              id: max,
              temporada: 'Temporada Baja', 
              adultos: adultos,
              ninos: ninos,
              precio: '10',
              pordefecto: 1
            });
          }
        }
      });
    });
  }
  AddTarifa() {
    $('#modal-crear-tarifa').modal('show');
    $('#modal-crear-tarifa .modal-title').html('Nueva tarifa');
    Object.keys(this.dataitem).forEach(item => {this.dataitem[item] = ''});
    if (this.temporadas.length) this.dataitem.id_temporada = this.temporadas[0].id;
    this.dataitem.pordefecto = (!this.data.tarifas || !this.data.tarifas.length ? 1 : 0);
    $('#chk-pordefecto').prop('checked', (!this.data.tarifas || !this.data.tarifas.length));
    setTimeout(() => {
      $('#modal-crear-tarifa input[type="number"]')[0].focus();
    }, 500);
  }
  EditTarifa(item:any) {
    $('#modal-crear-tarifa').modal('show');
    $('#modal-crear-tarifa .modal-title').html('Editar tarifa');
    this.dataitem = JSON.parse(JSON.stringify(item));
    $('#chk-pordefecto').prop('checked', this.dataitem.pordefecto);
    setTimeout(() => {
      $('#modal-crear-tarifa input[type="number"]')[0].focus();
    }, 500);
  }
  DelTarifa(item:any) {
    if (!item || !item.id) {
      this.data.tarifas.splice(this.data.tarifas.findIndex(el => el.temporada == item.temporada && el.precio == item.precio), 1);
      return;
    }
    if (!this.data.id || this.data.id == '') return;
    swal({
      title: "¿Borrar tarifa?",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn-primary",
      confirmButtonText: "Sí",
      cancelButtonText: "No",
      closeOnConfirm: true
    },() => {
      this.globals.Api('/alo-alojamientos-tarifas-del', {id_alojamiento: this.data.id, id: item.id}).subscribe(data => {
        if (!data || data.error) {
          swal('Error', 'Se ha producido un error', 'error');return;
        }
        this.data.tarifas.splice(this.data.tarifas.findIndex(el => el.id == item.id), 1);
        this.appref.tick();
      });
    });
  }
  GuardarTarifa() {
    if (!this.dataitem.adultos) this.dataitem.adultos = 0;
    if (!this.dataitem.ninos) this.dataitem.ninos = 0;
    if (
         !this.dataitem.adultos
      || this.dataitem.adultos.toString() == ''
      || this.dataitem.ninos.toString() == ''
      || this.dataitem.precio.toString() == ''
      ) {
      swal('Complete campos', 'Por favor, rellene todos los campos obligatorios para continuar', 'error');return;
    }
    this.dataitem.pordefecto = $('#chk-pordefecto').prop('checked');
    if (this.dataitem.pordefecto) this.dataitem.id_temporada = null;

    if (!this.data.id || this.data.id == '') {
      if (!this.data.tarifas) this.data.tarifas = [];
      this.dataitem.temporada = ($('#cmb-temporada option:selected').text() != '' ? $('#cmb-temporada option:selected').text() : 'Temporada Baja');
      let max = 0;
      this.data.tarifas.forEach(item => {if (parseInt(item.id) > max) max = item.id;});
      max = max+1;
      this.data.tarifas.push({
        id_temporada: this.dataitem.id_temporada,
        id: max,
        temporada: (!this.dataitem.pordefecto && $('#cmb-temporada option:selected').text() != '' ? $('#cmb-temporada option:selected').text() : 'Temporada Baja'), 
        adultos: this.dataitem.adultos,
        ninos: this.dataitem.ninos,
        precio: this.dataitem.precio,
        pordefecto: this.dataitem.pordefecto
      });
      $('#modal-crear-tarifa').modal('hide');
      return;
    } 

    if (!this.dataitem.id || this.dataitem.id == '') {
      $.buttonloading('btn-guardar-tarifa', 'Enviando');
      this.dataitem.id_alojamiento = this.data.id;
      this.globals.Api('/alo-alojamientos-tarifas-add', this.dataitem).subscribe(data => {
        $.buttoncancelloading('btn-guardar-tarifa');
        if (!data || data.error) {
          swal('Error', 'Se ha producido un error', 'error');return;
        }
        if (!this.data.tarifas) this.data.tarifas = [];
        this.data.tarifas.push({
          id: data.value,
          id_temporada: this.dataitem.id_temporada, 
          temporada: ($('#cmb-temporada option:selected').text() != '' ? $('#cmb-temporada option:selected').text() : 'Temporada Baja'), 
          adultos: this.dataitem.adultos,
          ninos: this.dataitem.ninos,
          precio: this.dataitem.precio,
          pordefecto: this.dataitem.pordefecto
        });
        $('#modal-crear-tarifa').modal('hide');
      }, error => {
        $.buttoncancelloading('btn-guardar-tarifa');
      });
    } else {
      $.buttonloading('btn-guardar-tarifa', 'Enviando');
      this.dataitem.id_alojamiento = this.data.id;
      this.globals.Api('/alo-alojamientos-tarifas-edit', this.dataitem).subscribe(data => {
        $.buttoncancelloading('btn-guardar-tarifa');
        if (!data || data.error) {
          swal('Error', 'Se ha producido un error', 'error');return;
        }
        let item = this.data.tarifas.filter(el => el.id == this.dataitem.id);
        if (item && item.length) item = item[0];
        item.id_temporada = this.dataitem.id_temporada;
        item.temporada = ($('#cmb-temporada option:selected').text() != '' ? $('#cmb-temporada option:selected').text() : 'Temporada Baja');
        item.adultos = this.dataitem.adultos;
        item.ninos = this.dataitem.ninos;
        item.precio = this.dataitem.precio;
        item.pordefecto = this.dataitem.pordefecto;
        toastr.success(`Datos guardados correctamente`, 'Guardado');
        $('#modal-crear-tarifa').modal('hide');
      }, error => {
        $.buttoncancelloading('btn-guardar-tarifa');
      });
    }
  }

  //Rango fechas
  BloquearRangoFechas(){
    let fechaInicioBloqueoRango = $('#date-rangue-block-start').val();
    let fechaFinBloqueoRango = $('#date-rangue-block-end').val();
    let cont = 0;
    let fechaBloqueo = [];
    fechaBloqueo.push(moment(fechaInicioBloqueoRango).format('YYYY-MM-DD'));
    do{
      // console.log(fechaInicioBloqueoRango);
      // console.log(fechaInicioBloqueoRango);
      fechaInicioBloqueoRango = moment(fechaInicioBloqueoRango).add(+1,'days').format('YYYY-MM-DD');
      fechaBloqueo.push(moment(fechaInicioBloqueoRango).format('YYYY-MM-DD'));
    }while(fechaInicioBloqueoRango != fechaFinBloqueoRango || cont == 50);
    this.globals.Api('/alo-alojamientos-fechas-bloqueadas-add-rangue', {id_alojamiento: this.data.id, fechas: fechaBloqueo}).subscribe(data => {
      if (!data || data.error) {
        swal('Error', 'Se ha producido un error', 'error');return;
      }
      if (!this.data.fechas_bloquedas) this.data.fechas_bloquedas = [];
      if (!this.fechas_bloqueadas) this.fechas_bloqueadas = [];
      for(let item of fechaBloqueo){
        this.data.fechas_bloquedas.push({id_alojamiento: this.data.id, fecha: item});
        this.fechas_bloqueadas.push(item);
      }
      $('#calendario-cierres').datepicker('update', moment(fechaFinBloqueoRango).format('DD-MM-YYYY'));
      let objFechasBloqueoRangue = {
        id_alojamiento: this.data.id,
        fecha_inicio: moment($('#date-rangue-block-start').val()).format('YYYY-MM-DD'),
        fecha_fin: moment($('#date-rangue-block-end').val()).format('YYYY-MM-DD')
      };
      this.globals.Api('/alo-alojamientos-fechas-bloqueadas-add-rangue-table', objFechasBloqueoRangue).subscribe(data => {
        if (!data || data.error) {
          swal('Error', 'Se ha producido un error', 'error');return;
        }
        this.fechas_bloqueadas_rango.push({id: data.value, 
          id_alojamiento: this.data.id,
          fecha_inicio: moment($('#date-rangue-block-start').val()).format('YYYY-MM-DD'),
          fecha_fin: moment($('#date-rangue-block-end').val()).format('YYYY-MM-DD'),
          fecha_inicio_format: moment($('#date-rangue-block-start').val()).format('DD/MM/YYYY'),
          fecha_fin_format: moment($('#date-rangue-block-end').val()).format('DD/MM/YYYY')});
      });
    });
  }
  DelFechasRangue(item:any){
    let fechaInicioBloqueoRango = moment(item.fecha_inicio).format('YYYY-MM-DD');
    let fechaFinBloqueoRango = moment(item.fecha_fin).format('YYYY-MM-DD');
    let fechaBloqueo = [];
    let cont = 0;
    fechaBloqueo.push(fechaInicioBloqueoRango);
    console.log(item);
    do{
      fechaInicioBloqueoRango = moment(fechaInicioBloqueoRango).add(+1,'days').format('YYYY-MM-DD');
      fechaBloqueo.push(moment(fechaInicioBloqueoRango).format('YYYY-MM-DD'));
    }while(fechaInicioBloqueoRango != fechaFinBloqueoRango || cont == 50);
    this.globals.Api('/alo-alojamientos-fechas-bloqueadas-del-rangue', {id_alojamiento: this.data.id, id: item.id, fechas: fechaBloqueo}).subscribe(data => {
      if (!data || data.error) {
        swal('Error', 'Se ha producido un error', 'error');return;
      }
      // if (!this.data.fechas_bloquedas) this.data.fechas_bloquedas = [];
      // if (!this.fechas_bloqueadas) this.fechas_bloqueadas = [];
      for(let item of fechaBloqueo){
        // this.data.fechas_bloquedas.push({id_alojamiento: this.data.id, fecha: item});
        // this.fechas_bloqueadas.push(item);
        if (this.data.fechas_bloquedas) this.data.fechas_bloquedas.splice(this.data.fechas_bloquedas.findIndex(el => el.fecha == item), 1);
        if (this.fechas_bloqueadas) this.fechas_bloqueadas.splice(this.fechas_bloqueadas.findIndex(el => el == item), 1);
        //console.log('Delete fecha object: ' + item);
      }
      $('#calendario-cierres').datepicker('update', moment(fechaFinBloqueoRango).format('DD-MM-YYYY'));
      let objFechasBloqueoRangue = {
        id_alojamiento: this.data.id,
        fecha_inicio: moment(item.fecha_inicio).format('YYYY-MM-DD'),
        fecha_fin: moment(item.fecha_fin).format('YYYY-MM-DD')
      };
      this.globals.Api('/alo-alojamientos-fechas-bloqueadas-del-rangue-table', objFechasBloqueoRangue).subscribe(data => {
        if (!data || data.error) {
          swal('Error', 'Se ha producido un error', 'error');return;
        }
        this.fechas_bloqueadas_rango = [];
        this.LoadFechasBloqueadasRango();
      });
    });
  }

  //Minimo noches
  AddMinimoNoches() {
    let inicio = $('#calendario-noches').data('daterangepicker').startDate;
    let fin = $('#calendario-noches').data('daterangepicker').endDate;
    if (
         !inicio
      || !fin
      || !this.num_minimo_noches
      ) {
      swal('Seleccione rango', 'Por favor, selecciona un rango de fechas para continuar', 'error');return;
    }
    let clearInput = false;
    if (this.data.minimo_noches && this.data.minimo_noches.length) {
      for (let item of this.data.minimo_noches) {
        if (
          (moment(inicio)<=moment(item.fecha_inicio) && moment(fin)>=moment(item.fecha_inicio))
          || (moment(inicio)<=moment(item.fecha_fin) && moment(fin)>=moment(item.fecha_fin))
         ) {
          clearInput = true;
          break;
        }
      }
    }
    if (clearInput) {
      swal('Rango no válido', 'El rango de fechas no puede solapar a otro', 'error');return;
    }
    
    let params = {
      id: null,
      id_alojamiento: this.data.id, 
      fecha_inicio: moment(inicio).format('YYYY-MM-DD'),
      fecha_fin: moment(fin).format('YYYY-MM-DD'),
      fecha_inicio_format: moment(inicio).format('DD/MM/YYYY'),
      fecha_fin_format: moment(fin).format('DD/MM/YYYY'),
      num_minimo_noches: this.num_minimo_noches,
      reciente: true
    };
    $.buttonloading('btn-add-minimo-noches', 'Enviando');
    this.globals.Api('/alo-alojamientos-minimo-noches-add', params).subscribe(data => {
      $.buttoncancelloading('btn-add-minimo-noches');
      if (!data || data.error) {
        swal('Error', 'Se ha producido un error', 'error');return;
      }
      params.id = data.value;
      this.data.minimo_noches.unshift(params);
      this.LoadFechasMinimoNoches();
      $('#calendario-noches').data('daterangepicker').setEndDate(null);
      $('#calendario-noches').data('daterangepicker').setStartDate(moment(inicio));
      $.ResetColores();
    }, error => {
      $.buttoncancelloading('btn-add-minimo-noches');
    });
  }
  DelMinimoNoche(item:any){
    swal({
      title: "¿Borrar rango de mínimo por noche?",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn-primary",
      confirmButtonText: "Sí",
      cancelButtonText: "No",
      closeOnConfirm: true
    },() => {
      this.globals.Api('/alo-alojamientos-minimo-noches-del', {id_alojamiento: this.data.id, id: item.id}).subscribe(data => {
        if (!data || data.error) {
          swal('Error', 'Se ha producido un error', 'error');return;
        }
        this.data.minimo_noches.splice(this.data.minimo_noches.findIndex(el => el.id == item.id), 1);
        this.LoadFechasMinimoNoches();
        $('#calendario-noches').data('daterangepicker').setEndDate(null);
        $('#calendario-noches').data('daterangepicker').setStartDate(moment(item.fecha_inicio));
        $.ResetColores();
      });
    });
  }

  public iconos = ["angry-monster","bathtub","bird-wings","bow","castle","circuit","crown-king","crown-queen","dart","disability-race","diving-goggle","eye-open","flora-flower","flora","gift-box","halloween-pumpkin","hand-power","hand-thunder","king-monster","love","magician-hat","native-american","owl-look","phoenix","robot-face","sand-clock","shield-alt","ship-wheel","skull-danger","skull-face","snowmobile","space-shuttle","star-shape","swirl","tattoo-wing","throne","tree-alt","triangle","unity-hand","weed","woman-bird","bat","bear-face","bear-tracks","bear","bird-alt","bird-flying","bird","birds","bone","bull","butterfly-alt","butterfly","camel-alt","camel-head","camel","cat-alt-1","cat-alt-2","cat-alt-3","cat-dog","cat-face","cat","cow-head","cow","crab","crocodile","deer-head","dog-alt","dog-barking","dog","dolphin","duck-tracks","eagle-head","eaten-fish","elephant-alt","elephant-head-alt","elephant-head","elephant","elk","fish-1","fish-2","fish-3","fish-4","fish-5","fish","fox-alt","fox","frog-tracks","frog","froggy","giraffe-head-1","giraffe-head-2","giraffe-head","giraffe","goat-head","gorilla","hen-tracks","horse-head-1","horse-head-2","horse-head","horse-tracks","jellyfish","kangaroo","lemur","lion-head-1","lion-head-2","lion-head","lion","monkey-2","monkey-3","monkey-face","monkey","octopus-alt","octopus","owl","panda-face","panda","panther","parrot-lip","parrot","paw","pelican","penguin","pig-face","pig","pigeon-1","pigeon-2","pigeon","rabbit","rat","rhino-head","rhino","rooster","seahorse","seal","shrimp-alt","shrimp","snail-1","snail-2","snail-3","snail","snake","squid","squirrel","tiger-face","tiger","turtle","whale","woodpecker","zebra","brand-acer","brand-adidas","brand-adobe","brand-air-new-zealand","brand-airbnb","brand-aircell","brand-airtel","brand-alcatel","brand-alibaba","brand-aliexpress","brand-alipay","brand-amazon","brand-amd","brand-american-airlines","brand-android-robot","brand-android","brand-aol","brand-apple","brand-appstore","brand-asus","brand-ati","brand-att","brand-audi","brand-axiata","brand-bada","brand-bbc","brand-bing","brand-blackberry","brand-bmw","brand-box","brand-burger-king","brand-business-insider","brand-buzzfeed","brand-cannon","brand-casio","brand-china-mobile","brand-china-telecom","brand-china-unicom","brand-cisco","brand-citibank","brand-cnet","brand-cnn","brand-cocal-cola","brand-compaq","brand-debian","brand-delicious","brand-dell","brand-designbump","brand-designfloat","brand-disney","brand-dodge","brand-dove","brand-drupal","brand-ebay","brand-eleven","brand-emirates","brand-espn","brand-etihad-airways","brand-etisalat","brand-etsy","brand-fastrack","brand-fedex","brand-ferrari","brand-fitbit","brand-flikr","brand-forbes","brand-foursquare","brand-foxconn","brand-fujitsu","brand-general-electric","brand-gillette","brand-gizmodo","brand-gnome","brand-google","brand-gopro","brand-gucci","brand-hallmark","brand-hi5","brand-honda","brand-hp","brand-hsbc","brand-htc","brand-huawei","brand-hulu","brand-hyundai","brand-ibm","brand-icofont","brand-icq","brand-ikea","brand-imdb","brand-indiegogo","brand-intel","brand-ipair","brand-jaguar","brand-java","brand-joomla","brand-kickstarter","brand-kik","brand-lastfm","brand-lego","brand-lenovo","brand-levis","brand-lexus","brand-lg","brand-life-hacker","brand-linux-mint","brand-linux","brand-lionix","brand-loreal","brand-louis-vuitton","brand-mac-os","brand-marvel-app","brand-mashable","brand-mazda","brand-mcdonals","brand-mercedes","brand-micromax","brand-microsoft","brand-mobileme","brand-mobily","brand-motorola","brand-msi","brand-mts","brand-myspace","brand-mytv","brand-nasa","brand-natgeo","brand-nbc","brand-nescafe","brand-nestle","brand-netflix","brand-nexus","brand-nike","brand-nokia","brand-nvidia","brand-omega","brand-opensuse","brand-oracle","brand-panasonic","brand-paypal","brand-pepsi","brand-philips","brand-pizza-hut","brand-playstation","brand-puma","brand-qatar-air","brand-qvc","brand-readernaut","brand-redbull","brand-reebok","brand-reuters","brand-samsung","brand-sap","brand-saudia-airlines","brand-scribd","brand-shell","brand-siemens","brand-sk-telecom","brand-slideshare","brand-smashing-magazine","brand-snapchat","brand-sony-ericsson","brand-sony","brand-soundcloud","brand-sprint","brand-squidoo","brand-starbucks","brand-stc","brand-steam","brand-suzuki","brand-symbian","brand-t-mobile","brand-tango","brand-target","brand-tata-indicom","brand-techcrunch","brand-telenor","brand-teliasonera","brand-tesla","brand-the-verge","brand-thenextweb","brand-toshiba","brand-toyota","brand-tribenet","brand-ubuntu","brand-unilever","brand-vaio","brand-verizon","brand-viber","brand-vodafone","brand-volkswagen","brand-walmart","brand-warnerbros","brand-whatsapp","brand-wikipedia","brand-windows","brand-wire","brand-wordpress","brand-xiaomi","brand-yahoobuzz","brand-yamaha","brand-youtube","brand-zain","bank-alt","bank","barcode","bill-alt","billboard","briefcase-1","briefcase-2","businessman","businesswoman","chair","coins","company","contact-add","files-stack","handshake-deal","id-card","meeting-add","money-bag","pie-chart","presentation-alt","presentation","stamp","stock-mobile","chart-arrows-axis","chart-bar-graph","chart-flow-1","chart-flow-2","chart-flow","chart-growth","chart-histogram-alt","chart-histogram","chart-line-alt","chart-line","chart-pie-alt","chart-pie","chart-radar-graph","architecture-alt","architecture","barricade","bolt","bricks","building-alt","bull-dozer","calculations","cement-mix","cement-mixer","concrete-mixer","danger-zone","drill","eco-energy","eco-environmen","energy-air","energy-oil","energy-savings","energy-solar","energy-water","engineer","fire-extinguisher-alt","fire-extinguisher","fix-tools","fork-lift","glue-oil","hammer-alt","hammer","help-robot","industries-1","industries-2","industries-3","industries-4","industries-5","industries","labour","mining","paint-brush","pollution","power-zone","radio-active","recycle-alt","recycling-man","safety-hat-light","safety-hat","saw","screw-driver","tools-1","tools-bag","tow-truck","trolley","trowel","under-construction-alt","under-construction","vehicle-cement","vehicle-crane","vehicle-delivery-van","vehicle-dozer","vehicle-excavator","vehicle-trucktor","vehicle-wrecking","worker","workers-group","wrench","afghani-false","afghani-minus","afghani-plus","afghani-true","afghani","baht-false","baht-minus","baht-plus","baht-true","baht","bitcoin-false","bitcoin-minus","bitcoin-plus","bitcoin-true","bitcoin","dollar-flase","dollar-minus","dollar-plus","dollar-true","dollar","dong-false","dong-minus","dong-plus","dong-true","dong","euro-false","euro-minus","euro-plus","euro-true","euro","frank-false","frank-minus","frank-plus","frank-true","frank","hryvnia-false","hryvnia-minus","hryvnia-plus","hryvnia-true","hryvnia","lira-false","lira-minus","lira-plus","lira-true","lira","peseta-false","peseta-minus","peseta-plus","peseta-true","peseta","peso-false","peso-minus","peso-plus","peso-true","peso","pound-false","pound-minus","pound-plus","pound-true","pound","renminbi-false","renminbi-minus","renminbi-plus","renminbi-true","renminbi","riyal-false","riyal-minus","riyal-plus","riyal-true","riyal","rouble-false","rouble-minus","rouble-plus","rouble-true","rouble","rupee-false","rupee-minus","rupee-plus","rupee-true","rupee","taka-false","taka-minus","taka-plus","taka-true","taka","turkish-lira-false","turkish-lira-minus","turkish-lira-plus","turkish-lira-true","turkish-lira","won-false","won-minus","won-plus","won-true","won","yen-false","yen-minus","yen-plus","yen-true","yen","android-nexus","android-tablet","apple-watch","drawing-tablet","earphone","flash-drive","game-console","game-controller","game-pad","game","headphone-alt-1","headphone-alt-2","headphone-alt-3","headphone-alt","headphone","htc-one","imac","ipad","iphone","ipod-nano","ipod-touch","keyboard-alt","keyboard-wireless","keyboard","laptop-alt","laptop","macbook","magic-mouse","micro-chip","microphone-alt","microphone","monitor","mouse","mp3-player","nintendo","playstation-alt","psvita","radio-mic","radio","refrigerator","samsung-galaxy","surface-tablet","ui-head-phone","ui-keyboard","washing-machine","wifi-router","wii-u","windows-lumia","wireless-mouse","xbox-360","arrow-down","arrow-left","arrow-right","arrow-up","block-down","block-left","block-right","block-up","bubble-down","bubble-left","bubble-right","bubble-up","caret-down","caret-left","caret-right","caret-up","circled-down","circled-left","circled-right","circled-up","collapse","cursor-drag","curved-double-left","curved-double-right","curved-down","curved-left","curved-right","curved-up","dotted-down","dotted-left","dotted-right","dotted-up","double-left","double-right","expand-alt","hand-down","hand-drag","hand-drag1","hand-drag2","hand-drawn-alt-down","hand-drawn-alt-left","hand-drawn-alt-right","hand-drawn-alt-up","hand-drawn-down","hand-drawn-left","hand-drawn-right","hand-drawn-up","hand-grippers","hand-left","hand-right","hand-up","line-block-down","line-block-left","line-block-right","line-block-up","long-arrow-down","long-arrow-left","long-arrow-right","long-arrow-up","rounded-collapse","rounded-double-left","rounded-double-right","rounded-down","rounded-expand","rounded-left-down","rounded-left-up","rounded-left","rounded-right-down","rounded-right-up","rounded-right","rounded-up","scroll-bubble-down","scroll-bubble-left","scroll-bubble-right","scroll-bubble-up","scroll-double-down","scroll-double-left","scroll-double-right","scroll-double-up","scroll-down","scroll-left","scroll-long-down","scroll-long-left","scroll-long-right","scroll-long-up","scroll-right","scroll-up","simple-down","simple-left-down","simple-left-up","simple-left","simple-right-down","simple-right-up","simple-right","simple-up","square-down","square-left","square-right","square-up","stylish-down","stylish-left","stylish-right","stylish-up","swoosh-down","swoosh-left","swoosh-right","swoosh-up","thin-double-left","thin-double-right","thin-down","thin-left","thin-right","thin-up","abc","atom","award","bell-alt","black-board","book-alt","book","brainstorming","certificate-alt-1","certificate-alt-2","certificate","education","electron","fountain-pen","globe-alt","graduate-alt","graduate","group-students","hat-alt","hat","instrument","lamp-light","medal","microscope-alt","microscope","paper","pen-alt-4","pen-nib","pencil-alt-5","quill-pen","read-book-alt","read-book","school-bag","school-bus","student-alt","student","teacher","test-bulb","test-tube-alt","university","angry","astonished","confounded","confused","crying","dizzy","expressionless","heart-eyes","laughing","nerd-smile","open-mouth","rage","rolling-eyes","sad","simple-smile","slightly-smile","smirk","stuck-out-tongue","wink-smile","worried","file-alt","file-audio","file-avi-mp4","file-bmp","file-code","file-css","file-document","file-eps","file-excel","file-exe","file-file","file-flv","file-gif","file-html5","file-image","file-iso","file-java","file-javascript","file-jpg","file-midi","file-mov","file-mp3","file-pdf","file-php","file-png","file-powerpoint","file-presentation","file-psb","file-psd","file-python","file-ruby","file-spreadsheet","file-sql","file-svg","file-text","file-tiff","file-video","file-wave","file-wmv","file-word","file-zip","cycling-alt","cycling","dumbbell","dumbbells","gym-alt-1","gym-alt-2","gym-alt-3","gym","muscle-weight","muscle","apple","arabian-coffee","artichoke","asparagus","avocado","baby-food","banana","bbq","beans","beer","bell-pepper-capsicum","birthday-cake","bread","broccoli","burger","cabbage","carrot","cauli-flower","cheese","chef","cherry","chicken-fry","chicken","cocktail","coconut-water","coconut","coffee-alt","coffee-cup","coffee-mug","coffee-pot","cola","corn","croissant","crop-plant","cucumber","culinary","cup-cake","dining-table","donut","egg-plant","egg-poached","farmer-alt","farmer","fast-food","food-basket","food-cart","fork-and-knife","french-fries","fruits","grapes","honey","hot-dog","ice-cream-alt","ice-cream","juice","ketchup","kiwi","layered-cake","lemon-alt","lemon","lobster","mango","milk","mushroom","noodles","onion","orange","pear","peas","pepper","pie-alt","pie","pineapple","pizza-slice","pizza","plant","popcorn","potato","pumpkin","raddish","restaurant-menu","restaurant","salt-and-pepper","sandwich","sausage","soft-drinks","soup-bowl","spoon-and-fork","steak","strawberry","sub-sandwich","sushi","taco","tea-pot","tea","tomato","watermelon","wheat","baby-backpack","baby-cloth","baby-milk-bottle","baby-trolley","baby","candy","holding-hands","infant-nipple","kids-scooter","safety-pin","teddy-bear","toy-ball","toy-cat","toy-duck","toy-elephant","toy-hand","toy-horse","toy-lattu","toy-train","burglar","cannon-firing","cc-camera","cop-badge","cop","court-hammer","court","finger-print","gavel","handcuff-alt","handcuff","investigation","investigator","jail","judge","law-alt-1","law-alt-2","law-alt-3","law-book","law-document","law-order","law-protect","law-scales","law","lawyer-alt-1","lawyer-alt-2","lawyer","legal","pistol","police-badge","police-cap","police-car-alt-1","police-car-alt-2","police-car","police-hat","police-van","police","thief-alt","thief","abacus-alt","abacus","angle-180","angle-45","angle-90","angle","calculator-alt-1","calculator-alt-2","calculator","circle-ruler-alt","circle-ruler","compass-alt-1","compass-alt-2","compass-alt-3","compass-alt-4","golden-ratio","marker-alt-1","marker-alt-2","marker-alt-3","marker","math","mathematical-alt-1","mathematical-alt-2","mathematical","pen-alt-1","pen-alt-2","pen-alt-3","pen-holder-alt-1","pen-holder","pen","pencil-alt-1","pencil-alt-2","pencil-alt-3","pencil-alt-4","pencil","ruler-alt-1","ruler-alt-2","ruler-compass-alt","ruler-compass","ruler-pencil-alt-1","ruler-pencil-alt-2","ruler-pencil","ruler","rulers-alt","rulers","square-root","ui-calculator","aids","ambulance-crescent","ambulance-cross","ambulance","autism","bandage","blind","blood-drop","blood-test","blood","brain-alt","brain","capsule","crutch","disabled","dna-alt-1","dna-alt-2","dna","doctor-alt","doctor","drug-pack","drug","first-aid-alt","first-aid","heart-beat-alt","heart-beat","heartbeat","herbal","hospital","icu","injection-syringe","laboratory","medical-sign-alt","medical-sign","nurse-alt","nurse","nursing-home","operation-theater","paralysis-disability","patient-bed","patient-file","pills","prescription","pulse","stethoscope-alt","stethoscope","stretcher","surgeon-alt","surgeon","tablets","test-bottle","test-tube","thermometer-alt","thermometer","tooth","xray","ui-add","ui-alarm","ui-battery","ui-block","ui-bluetooth","ui-brightness","ui-browser","ui-calendar","ui-call","ui-camera","ui-cart","ui-cell-phone","ui-chat","ui-check","ui-clip-board","ui-clip","ui-clock","ui-close","ui-contact-list","ui-copy","ui-cut","ui-delete","ui-dial-phone","ui-edit","ui-email","ui-file","ui-fire-wall","ui-flash-light","ui-flight","ui-folder","ui-game","ui-handicapped","ui-home","ui-image","ui-laoding","ui-lock","ui-love-add","ui-love-broken","ui-love-remove","ui-love","ui-map","ui-message","ui-messaging","ui-movie","ui-music-player","ui-music","ui-mute","ui-network","ui-next","ui-note","ui-office","ui-password","ui-pause","ui-play-stop","ui-play","ui-pointer","ui-power","ui-press","ui-previous","ui-rate-add","ui-rate-blank","ui-rate-remove","ui-rating","ui-record","ui-remove","ui-reply","ui-rotation","ui-rss","ui-search","ui-settings","ui-social-link","ui-tag","ui-text-chat","ui-text-loading","ui-theme","ui-timer","ui-touch-phone","ui-travel","ui-unlock","ui-user-group","ui-user","ui-v-card","ui-video-chat","ui-video-message","ui-video-play","ui-video","ui-volume","ui-weather","ui-wifi","ui-zoom-in","ui-zoom-out","cassette-player","cassette","forward","guiter","movie","multimedia","music-alt","music-disk","music-note","music-notes","music","mute-volume","pause","play-alt-1","play-alt-2","play-alt-3","play-pause","play","record","retro-music-disk","rewind","song-notes","sound-wave-alt","sound-wave","stop","video-alt","video-cam","video-clapper","video","volume-bar","volume-down","volume-mute","volume-off","volume-up","youtube-play","2checkout-alt","2checkout","amazon-alt","amazon","american-express-alt","american-express","apple-pay-alt","apple-pay","bank-transfer-alt","bank-transfer","braintree-alt","braintree","cash-on-delivery-alt","cash-on-delivery","diners-club-alt-1","diners-club-alt-2","diners-club-alt-3","diners-club","discover-alt","discover","eway-alt","eway","google-wallet-alt-1","google-wallet-alt-2","google-wallet-alt-3","google-wallet","jcb-alt","jcb","maestro-alt","maestro","mastercard-alt","mastercard","payoneer-alt","payoneer","paypal-alt","paypal","sage-alt","sage","skrill-alt","skrill","stripe-alt","stripe","visa-alt","visa-electron","visa","western-union-alt","western-union","boy","business-man-alt-1","business-man-alt-2","business-man-alt-3","business-man","female","funky-man","girl-alt","girl","group","hotel-boy-alt","hotel-boy","kid","man-in-glasses","people","support","user-alt-1","user-alt-2","user-alt-3","user-alt-4","user-alt-5","user-alt-6","user-alt-7","user-female","user-male","user-suited","user","users-alt-1","users-alt-2","users-alt-3","users-alt-4","users-alt-5","users-alt-6","users-social","users","waiter-alt","waiter","woman-in-glasses","search-1","search-2","search-document","search-folder","search-job","search-map","search-property","search-restaurant","search-stock","search-user","search","500px","aim","badoo","baidu-tieba","bbm-messenger","bebo","behance","blogger","bootstrap","brightkite","cloudapp","concrete5","delicious","designbump","designfloat","deviantart","digg","dotcms","dribbble","dribble","dropbox","ebuddy","ello","ember","envato","evernote","facebook-messenger","facebook","feedburner","flikr","folkd","foursquare","friendfeed","ghost","github","gnome","google-buzz","google-hangouts","google-map","google-plus","google-talk","hype-machine","instagram","kakaotalk","kickstarter","kik","kiwibox","line-messenger","line","linkedin","linux-mint","live-messenger","livejournal","magento","meetme","meetup","mixx","newsvine","nimbuss","odnoklassniki","opencart","oscommerce","pandora","photobucket","picasa","pinterest","prestashop","qik","qq","readernaut","reddit","renren","rss","shopify","silverstripe","skype","slack","slashdot","slidshare","smugmug","snapchat","soundcloud","spotify","stack-exchange","stack-overflow","steam","stumbleupon","tagged","technorati","telegram","tinder","trello","tumblr","twitch","twitter","typo3","ubercart","viber","viddler","vimeo","vine","virb","virtuemart","vk","wechat","weibo","whatsapp","xing","yahoo","yelp","youku","youtube","zencart","badminton-birdie","baseball","baseballer","basketball-hoop","basketball","billiard-ball","boot-alt-1","boot-alt-2","boot","bowling-alt","bowling","canoe","cheer-leader","climbing","corner","field-alt","field","football-alt","football-american","football","foul","goal-keeper","goal","golf-alt","golf-bag","golf-cart","golf-field","golf","golfer","helmet","hockey-alt","hockey","ice-skate","jersey-alt","jersey","jumping","kick","leg","match-review","medal-sport","offside","olympic-logo","olympic","padding","penalty-card","racer","racing-car","racing-flag-alt","racing-flag","racings-wheel","referee","refree-jersey","result-sport","rugby-ball","rugby-player","rugby","runner-alt-1","runner-alt-2","runner","score-board","skiing-man","skydiving-goggles","snow-mobile","steering","stopwatch","substitute","swimmer","table-tennis","team-alt","team","tennis-player","tennis","tracking","trophy-alt","trophy","volleyball-alt","volleyball-fire","volleyball","water-bottle","whistle-alt","whistle","win-trophy","align-center","align-left","align-right","all-caps","bold","brush","clip-board","code-alt","color-bucket","color-picker","copy-invert","copy","cut","delete-alt","edit-alt","eraser-alt","font","heading","indent","italic-alt","italic","justify-all","justify-center","justify-left","justify-right","link-broken","outdent","paper-clip","paragraph","pin","printer","redo","rotation","save","small-cap","strike-through","sub-listing","subscript","superscript","table","text-height","text-width","trash","underline","undo","air-balloon","airplane-alt","airplane","articulated-truck","auto-mobile","auto-rickshaw","bicycle-alt-1","bicycle-alt-2","bicycle","bus-alt-1","bus-alt-2","bus-alt-3","bus","cab","cable-car","car-alt-1","car-alt-2","car-alt-3","car-alt-4","car","delivery-time","fast-delivery","fire-truck-alt","fire-truck","free-delivery","helicopter","motor-bike-alt","motor-bike","motor-biker","oil-truck","rickshaw","rocket-alt-1","rocket-alt-2","rocket","sail-boat-alt-1","sail-boat-alt-2","sail-boat","scooter","sea-plane","ship-alt","ship","speed-boat","taxi","tractor","train-line","train-steam","tram","truck-alt","truck-loaded","truck","van-alt","van","yacht","5-star-hotel","air-ticket","beach-bed","beach","camping-vest","direction-sign","hill-side","hill","hotel","island-alt","island","sandals-female","sandals-male","travelling","breakdown","celsius","clouds","cloudy","dust","eclipse","fahrenheit","forest-fire","full-night","full-sunny","hail-night","hail-rainy-night","hail-rainy-sunny","hail-rainy","hail-sunny","hail-thunder-night","hail-thunder-sunny","hail-thunder","hail","hill-night","hill-sunny","hurricane","meteor","night","rainy-night","rainy-sunny","rainy-thunder","rainy","snow-alt","snow-flake","snow-temp","snow","snowy-hail","snowy-night-hail","snowy-night-rainy","snowy-night","snowy-rainy","snowy-sunny-hail","snowy-sunny-rainy","snowy-sunny","snowy-thunder-night","snowy-thunder-sunny","snowy-thunder","snowy-windy-night","snowy-windy-sunny","snowy-windy","snowy","sun-alt","sun-rise","sun-set","sun","sunny-day-temp","sunny","thunder-light","tornado","umbrella-alt","umbrella","volcano","wave","wind-scale-0","wind-scale-1","wind-scale-10","wind-scale-11","wind-scale-12","wind-scale-2","wind-scale-3","wind-scale-4","wind-scale-5","wind-scale-6","wind-scale-7","wind-scale-8","wind-scale-9","wind-waves","wind","windy-hail","windy-night","windy-raining","windy-sunny","windy-thunder-raining","windy-thunder","windy","addons","address-book","adjust","alarm","anchor","archive","at","attachment","audio","automation","badge","bag-alt","bag","ban","bar-code","bars","basket","battery-empty","battery-full","battery-half","battery-low","beaker","beard","bed","bell","beverage","bill","bin","binary","binoculars","bluetooth","bomb","book-mark","box","briefcase","broken","bucket","bucket1","bucket2","bug","building","bulb-alt","bullet","bullhorn","bullseye","calendar","camera-alt","camera","card","cart-alt","cart","cc","charging","chat","check-alt","check-circled","check","checked","children-care","clip","clock-time","close-circled","close-line-circled","close-line-squared-alt","close-line-squared","close-line","close-squared-alt","close-squared","close","cloud-download","cloud-refresh","cloud-upload","cloud","code-not-allowed","code","comment","compass-alt","compass","computer","connection","console","contacts","contrast","copyright","credit-card","crop","crown","cube","cubes","dashboard-web","dashboard","data","database-add","database-locked","database-remove","database","delete","diamond","dice-multiple","dice","disc","diskette","document-folder","download-alt","download","downloaded","drag","drag1","drag2","drag3","earth","ebook","edit","eject","email","envelope-open","envelope","eraser","error","excavator","exchange","exclamation-circle","exclamation-square","exclamation-tringle","exclamation","exit","expand","external-link","external","eye-alt","eye-blocked","eye-dropper","eye","favourite","fax","file-fill","film","filter","fire-alt","fire-burn","fire","flag-alt-1","flag-alt-2","flag","flame-torch","flash-light","flash","flask","focus","folder-open","folder","foot-print","garbage","gear-alt","gear","gears","gift","glass","globe","graffiti","grocery","hand","hanger","hard-disk","heart-alt","heart","history","home","horn","hour-glass","id","image","inbox","infinite","info-circle","info-square","info","institution","interface","invisible","jacket","jar","jewlery","karate","key-hole","key","label","lamp","layers","layout","leaf","leaflet","learn","lego","lens","letter","letterbox","library","license","life-bouy","life-buoy","life-jacket","life-ring","light-bulb","lighter","lightning-ray","like","line-height","link-alt","link","list","listening","listine-dots","listing-box","listing-number","live-support","location-arrow","location-pin","lock","login","logout","lollipop","long-drive","look","loop","luggage","lunch","lungs","magic-alt","magic","magnet","mail-box","mail","male","map-pins","map","maximize","measure","medicine","mega-phone","megaphone-alt","megaphone","memorial","memory-card","mic-mute","mic","military","mill","minus-circle","minus-square","minus","mobile-phone","molecule","money","moon","mop","muffin","mustache","navigation-menu","navigation","network-tower","network","news","newspaper","no-smoking","not-allowed","notebook","notepad","notification","numbered","opposite","optic","options","package","page","paint","paper-plane","paperclip","papers","pay","penguin-linux","pestle","phone-circle","phone","picture","pine","pixels","plugin","plus-circle","plus-square","plus","polygonal","power","price","print","puzzle","qr-code","queen","question-circle","question-square","question","quote-left","quote-right","random","recycle","refresh","repair","reply-all","reply","resize","responsive","retweet","road","robot","royal","rss-feed","safety","sale-discount","satellite","send-mail","server","settings-alt","settings","share-alt","share-boxed","share","shield","shopping-cart","sign-in","sign-out","signal","site-map","smart-phone","soccer","sort-alt","sort","space","spanner","speech-comments","speed-meter","spinner-alt-1","spinner-alt-2","spinner-alt-3","spinner-alt-4","spinner-alt-5","spinner-alt-6","spinner","spreadsheet","square","ssl-security","star-alt-1","star-alt-2","star","street-view","support-faq","tack-pin","tag","tags","tasks-alt","tasks","telephone","telescope","terminal","thumbs-down","thumbs-up","tick-boxed","tick-mark","ticket","tie","toggle-off","toggle-on","tools-alt-2","tools","touch","traffic-light","transparent","tree","unique-idea","unlock","unlocked","upload-alt","upload","usb-drive","usb","vector-path","verification-check","wall-clock","wall","wallet","warning-alt","warning","water-drop","web","wheelchair","wifi-alt","wifi","world","zigzag","zipped"];
}
